import { useState, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// pages
import Register from '../pages/auth/Register';
// components
import LoadingScreen from '../components/LoadingScreen';
import useEmbedded from "../hooks/useEmbedded";
import { getFromStorage, LocalStorageKeys, removeFromStorage } from "../utils/localStorageUtil";
import { BASE_URL } from "../config";
import { PATH_DASHBOARD } from "../routes/paths";

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isInitialized, logout } = useAuth();
  const { isEmbedded, postMessageToParent } = useEmbedded();

  const { pathname, state } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated && !(state as { inviteFlow: boolean})?.inviteFlow) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Register />;
  }
  if (isAuthenticated && isEmbedded) {
    const verifiedInIframe = getFromStorage(LocalStorageKeys.VERIFIED_IN_IFRAME)
    if (verifiedInIframe) {
      postMessageToParent({
        type: 'PORTAL_SIGNED_UP',
        payload: `${BASE_URL}${PATH_DASHBOARD.root}`
      })
    } else {
      logout();
    }
  }
  if(isAuthenticated && !isEmbedded) {
    removeFromStorage(LocalStorageKeys.VERIFIED_IN_IFRAME)
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
